import { get } from 'lodash';
import * as Analytics from 'common/utils/analytics';


const { AuthManager } = window.CVP;


class AuthTracker {

    initialized = false;

    pickerState = '';

    pickerStates = {
        findbylogo: 'tve: picker icon',
        findbyname: 'tve: picker list',
        noprovider: 'tve: provider not available'
    };

    constructor() {
        AuthManager.on('trackingData', this.onTrackingData, this);
        AuthManager.on('pickerMvpdSelected', this.onPickerMvpdSelected, this);
        AuthManager.on('pickerStateChange', this.onPickerStateChange, this);
    }

    destroy() {
        AuthManager.off('trackingData', this.onTrackingData);
        AuthManager.off('pickerMvpdSelected', this.onPickerMvpdSelected);
        AuthManager.off('pickerStateChange', this.onPickerStateChange);
    }

    onPickerMvpdSelected({ mvpdId }) {
        Analytics.trackMetrics('picker-click', {
            interaction: this.pickerState || this.pickerStates.findbyname,
            tve_mvpd: mvpdId
        });
    }

    onPickerStateChange(e) {
        const state = this.pickerStates[e.state];
        if (state) {
            this.pickerState = state;
            Analytics.trackMetrics('picker-pageview', {
                page_name: state,
                tve_mvpd: get(e, 'provider.ID', '')
            });
        }
    }

    onTrackingData({ eventType, trackingData }) {
        switch (eventType) {
            case 'authenticationDetection':
                this.trackAuthenticationDetection(trackingData);
                break;
            case 'mvpdSelection':
                Analytics.trackAuthenticationStart(trackingData);
                break;
        }
    }

    trackAuthenticationDetection(trackingData) {
        const succeeded = trackingData[0];
        const providerID = trackingData[1];
        const cached = trackingData[3];
        if (succeeded && cached) {
            Analytics.trackAlreadyLoggedInPage(trackingData);
        } else if (succeeded && !cached) {
            Analytics.trackMetrics('picker-pageview', {
                page_name: 'tve: successful login',
                tve_mvpd: providerID
            });
            Analytics.trackAuthenticationComplete(trackingData);
        } else if (!succeeded && this.initialized) {
            Analytics.trackNotLoggedInPage(trackingData);
        }
        this.initialized = true;
    }
}


export default new AuthTracker();



// WEBPACK FOOTER //
// ./src/common/analytics/auth-tracker.js